export enum DayStatus {
	Unavailable = 'Unavailable',
	Available = 'Available',
	PartiallyAvailable = 'Partially Available',
}
